var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "cff9f87c-a1bf-486b-8317-ec908d6ea44f"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "32dc56d8-3258-462c-817a-075f758273c9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.51 0 0 6.51 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 56.85 -23.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,139,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-18.15,22.65 4.35,34.45 0.05,9.55 18.15,-8.15 -6.85,-11.85 -18.15,-34.45 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 20.6 -23.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(251,176,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "18.1,-34.45 6.9,-11.85 -18.1,-8.15 0,9.55 -4.3,34.45 18.1,22.65 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 38.75 -21.35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "11.25,-2.45 3.45,-3.55 -0.05,-10.65 -3.45,-3.55 -11.25,-2.45 -5.65,2.95 -6.95,10.65 -0.05,7.05 6.95,10.65 5.55,2.95 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.45 -50.35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,139,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-12.95,16.15 3.05,24.65 -0.05,6.75 12.95,-5.85 -4.95,-8.45 -12.95,-24.65 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -36.35 -50.35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(251,176,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "12.95,-24.65 4.95,-8.45 -12.95,-5.85 0.05,6.75 -3.05,24.65 12.95,16.15 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -23.4 -48.75)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "8,-1.85 2.5,-2.65 0,-7.65 -2.5,-2.65 -8,-1.85 -4,2.05 -4.9,7.65 0,5.05 4.9,7.65 4,2.05 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.3 36.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,233)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-133.3, -111.8)",
    d: "M 133.3 95.2 L 134.3 99 C 135.9 104.8 140.4 109.3 146.10000000000002 110.8 L 149.90000000000003 111.8 L 146.10000000000002 112.8 C 140.3 114.39999999999999 135.8 118.89999999999999 134.3 124.6 L 133.3 128.4 L 132.3 124.60000000000001 C 130.70000000000002 118.80000000000001 126.20000000000002 114.30000000000001 120.50000000000001 112.80000000000001 L 116.70000000000002 111.80000000000001 L 120.50000000000001 110.80000000000001 C 126.30000000000001 109.20000000000002 130.8 104.70000000000002 132.3 99.00000000000001 L 133.3 95.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.1 -16.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,233)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12.9, -58.4)",
    d: "M 12.9 45.5 L 13.700000000000001 48.4 C 14.9 52.9 18.400000000000002 56.4 22.9 57.599999999999994 L 25.799999999999997 58.39999999999999 L 22.9 59.19999999999999 C 18.4 60.39999999999999 14.899999999999999 63.89999999999999 13.7 68.39999999999999 L 12.899999999999999 71.3 L 12.099999999999998 68.39999999999999 C 10.899999999999999 63.89999999999999 7.399999999999998 60.39999999999999 2.8999999999999986 59.19999999999999 L 0 58.5 L 2.9 57.7 C 7.4 56.5 10.9 53 12.1 48.5 L 12.9 45.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.82 29.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(245,168,108)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-61.18, -104.05)",
    d: "M 93.1 106.7 C 96.69999999999999 103.10000000000001 96.8 97.4 93.3 93.7 C 91.39999999999999 91.60000000000001 88.89999999999999 90.5 86.1 90.5 C 79.39999999999999 90.5 72.6 90.5 65.89999999999999 90.5 C 65.49999999999999 90.5 65.19999999999999 90.6 64.8 90.3 C 65.39999999999999 88.1 66.1 85.89999999999999 66.7 83.7 C 67.10000000000001 82.3 67.7 81 67.8 79.5 C 67.8 77.6 67.89999999999999 75.7 67.7 73.8 C 67.4 69.7 65.8 66.3 63 63.4 C 60 60.3 56.2 58.699999999999996 51.9 58.4 C 48.9 58.199999999999996 47.1 60 47.1 62.9 C 47.1 66.2 47.1 69.5 47.1 72.7 C 47.1 73.2 47 73.60000000000001 46.7 74 C 44.2 77.4 41.300000000000004 80.4 38.6 83.6 C 36.4 86.1 34.2 88.6 31.900000000000002 91 C 30.200000000000003 92.9 28.400000000000002 94.7 26.6 96.6 C 26.6 97 26.5 97.3 26.5 97.69999999999999 C 26.5 104.39999999999999 26.5 111.19999999999999 26.5 117.89999999999999 C 26.5 117.89999999999999 26.6 117.89999999999999 26.6 117.89999999999999 C 26.6 124.19999999999999 26.6 130.5 26.6 136.79999999999998 C 26.6 139.1 26.6 141.39999999999998 26.6 143.7 C 28.900000000000002 144.5 31.200000000000003 145.29999999999998 33.4 146.2 C 39.4 148.7 45.7 149.79999999999998 52.2 149.7 C 61.300000000000004 149.6 70.4 149.7 79.4 149.7 C 80.30000000000001 149.7 81.10000000000001 149.7 82 149.5 C 86.9 148.5 90.5 143.7 89.5 138.3 C 89.2 136.9 88.6 135.60000000000002 87.8 134.3 C 88 134.20000000000002 88.1 134.10000000000002 88.2 134.10000000000002 C 91.9 131.10000000000002 92.9 125.60000000000002 90.2 121.50000000000003 C 89.9 121.10000000000002 90 120.80000000000003 90.4 120.50000000000003 C 91.2 119.80000000000003 92 119.00000000000003 92.5 118.00000000000003 C 94.5 114.40000000000003 94.2 111.00000000000003 91.9 107.50000000000003 C 92.3 107.5 92.7 107.1 93.1 106.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -51 44.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,233)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -4.2,
    y: -26.2,
    rx: 0,
    ry: 0,
    width: 8.4,
    height: 52.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.15 28.95)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,94,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -9.85,
    y: -15.35,
    rx: 0,
    ry: 0,
    width: 19.7,
    height: 30.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.15 59.65)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(18,49,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -9.85,
    y: -15.35,
    rx: 0,
    ry: 0,
    width: 19.7,
    height: 30.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/excellence.7e37364ceb039fac4789bd2c00ecae33.svg";
export { ForwardRef as ReactComponent };